import { ImageApiResponse } from '../components/Image.types'
import { MetaDataApiResponse } from '../components/metaData.types'

export enum LinkType {
  INTERNAL = 'internal',
  EXTERNAL = 'external',
}

export enum IconBackgroundColor {
  BLUE = 'blue',
  ORANGE = 'orange',
  GREEN = 'green',
  PURPLE = 'purple',
  YELLOW = 'yellow',
}

export enum Shape {
  CIRCLE = 'circle',
  SQUARE = 'square',
}

export type ReeveButtonApiResponse = {
  link: string
  type: LinkType
  label: string
}

export type ReeveIconButtonApiResponse = {
  link: string
  type: LinkType
  label: string
  icon: ImageApiResponse
}

export type SectionHeaderApiResponse = {
  data: {
    reeveLandingPage: {
      navigation: {
        logo: ImageApiResponse
        primaryButton: ReeveButtonApiResponse
        secondaryButton: ReeveButtonApiResponse
      }
    }
  }
}

export type SectionHeroApiResponse = {
  data: {
    reeveLandingPage: {
      hero: {
        heading: string
        subHeading: string
        button: ReeveButtonApiResponse
      }
    }
  }
}

type Statement = {
  icon: ImageApiResponse
  iconBackgroundColor: IconBackgroundColor
  heading: string
  subHeading: string
}

export type SectionMissionApiResponse = {
  data: {
    reeveLandingPage: {
      mission: {
        image: ImageApiResponse
        caption: string
        heading: string
        subHeading: string
        statement: Statement[]
      }
    }
  }
}

export type SectionVideoApiResponse = {
  data: {
    reeveLandingPage: {
      video: {
        url: string
        caption: string
        thumbnail: ImageApiResponse
        thumbnailMobile: ImageApiResponse
      }
    }
  }
}

export type FeatureList = {
  icon: ImageApiResponse
  image: ImageApiResponse
  heading: string
  subHeading: string
  bulletPoint?:
    | {
        text: string
      }[]
    | null
}

export type SectionFeaturesApiResponse = {
  data: {
    reeveLandingPage: {
      features: {
        caption: string
        heading: string
        featureList: FeatureList[]
      }
    }
  }
}

export type Card = {
  image: ImageApiResponse
  icon: ImageApiResponse
  iconBackgroundColor: IconBackgroundColor
  heading: string
  subHeading: string
}

export type SectionHowWeHelpApiResponse = {
  data: {
    reeveLandingPage: {
      howWeHelp: {
        caption: string
        heading: string
        card: Card[]
      }
    }
  }
}

export type SectionCTAApiResponse = {
  data: {
    reeveLandingPage: {
      CTA: {
        heading: string
        primaryButton: ReeveIconButtonApiResponse
        secondaryButton: ReeveIconButtonApiResponse
        videoUrl: string
      }
    }
  }
}

export type Accordion = {
  question: string
  answer: string
}

export type SectionFAQApiResponse = {
  data: {
    reeveLandingPage: {
      FAQ: {
        caption: string
        heading: string
        accordion: Accordion[]
      }
    }
  }
}

export interface ComponentReeveCarouselIcon {
  __typename: 'ComponentReeveCarouselIcon'
  icon: ImageApiResponse
  shape: Shape
  iconColor: IconBackgroundColor
}

export interface ComponentReeveCarouselText {
  __typename: 'ComponentReeveCarouselText'
  text: string
  textColor: IconBackgroundColor
}

export type SectionCarouselApiResponse = {
  data: {
    reeveLandingPage: {
      carousel: (ComponentReeveCarouselIcon | ComponentReeveCarouselText)[]
    }
  }
}

export type SectionFormApiResponse = {
  data: {
    reeveLandingPage: {
      form: {
        title: string
        region: string
        portalId: string
        formId: string
      }
    }
  }
}

export type ReeveLandingPageMetaDataApiResponse = {
  data: {
    reeveLandingPage: MetaDataApiResponse
  }
}

export type ReeveLandingPagePublishedAtApiResponse = {
  data: {
    reeveLandingPage: {
      publishedAt: string
    }
  }
}
